import EventBorderListCard from 'src/component/screen/eventborderlist/EventBorderListCard';

export function EventBorderListScreen(): JSX.Element {
  return <EventBorderListCard />;
}
